import React, { createContext, useContext, useState } from "react";

const CurrencySelectionContext = createContext();

export const CurrencySelectionProvider = ({ children }) => {
  const [selectedAsset, setSelectedAsset] = useState(null);

  const selectedCurrency = selectedAsset?.asset?.toUpperCase() || "ZAR";
  const isCrypto = selectedAsset?.asset?.toUpperCase()
    ? selectedAsset.asset.toUpperCase() !== "ZAR"
    : false;

  const value = {
    selectedAsset,
    setSelectedAsset,
    selectedCurrency,
    isCrypto,
  };

  return (
    <CurrencySelectionContext.Provider value={value}>
      {children}
    </CurrencySelectionContext.Provider>
  );
};

export const useCurrencySelection = () => {
  const context = useContext(CurrencySelectionContext);
  if (!context) {
    return {
      selectedAsset: null,
      setSelectedAsset: () => {},
      selectedCurrency: "USD",
      isCrypto: true,
      isInProvider: false,
    };
  }
  return { ...context, isInProvider: true };
};
